export function getVATCountryShort(country: string): string {
    const formattedCountry = country.toUpperCase();
    const countryMap = {
        EE: '',
        GR: 'el',
    }

    if (formattedCountry in countryMap) {
        return countryMap[formattedCountry];
    }
    return country.toLowerCase();
}
